/* globals $ Craft */

import { PageBuilder } from "./components/page-builder";
import { AppCookies } from "./components/cookies";
import { Tooltips } from "./components/tooltips";
import { register } from "swiper/element/bundle";
import { Analytics } from "./components/analytics";
import * as Sentry from "@sentry/browser";

register();

class App {
  constructor() {
    this.cookies = new AppCookies();
    this.tooltips = new Tooltips();
    new PageBuilder();
    this.initHeader();
    this.initPhoneApp();
    this.initForms();
    this.initCryptedEmails($("body"));
    this.initNows();
    this.initSentry();
    if (Craft.env === "production") {
      console.log = function () {};
    }
    new Analytics(this.cookies.checkConsent("analytics"));
    $("body").css("opacity", 1);
    let height = $("header").height() + $("footer").height() - 10;
    $("main").css("min-height", "calc(100vh - " + height + "px)");
    console.log("App initialised");
  }

  initSentry() {
    if (Craft.sentryDsn) {
      Sentry.init({
        dsn: Craft.sentryDsn,
        sendDefaultPii: true,
      });
    }
  }

  initCryptedEmails($context) {
    $context.find(".js-lsnfgbshf").each((index, element) => {
      $(element).on("click", (e) => {
        let email =
          $(e.currentTarget).data("first").split("").reverse().join("") +
          "@" +
          $(e.currentTarget).data("second").split("").reverse().join("");
        $(element).attr("href", "mailto:" + email);
      });
    });
  }

  initForms() {
    if ($("form").length) {
      this.getForms();
    }
  }

  getForms() {
    if (!this.formsRequest) {
      this.formsRequest = import(/* webpackChunkName: "forms" */ "./components/forms").then((chunk) => {
        this.forms = new chunk.Forms();
      });
    }
    return this.formsRequest;
  }

  disableBodyScroll() {
    $("body, html").addClass("overflow-hidden relative h-full");
  }

  enableBodyScroll() {
    $("body, html").removeClass("overflow-hidden relative h-full");
  }

  initPhoneApp() {
    if ($(".swiss-popup-app").length) {
      import(/* webpackChunkName: "app-popup" */ "./components/app-popup").then((chunk) => {
        new chunk.AppPopup($(".swiss-popup-app"));
      });
    }
  }

  initHeader() {
    if ($("header").length) {
      import(/* webpackChunkName: "header" */ "./components/header").then((chunk) => {
        new chunk.Header();
      });
    }
  }

  initNows() {
    $(".js-now").html(new Date().toLocaleString());
  }

  refreshCsrfToken() {
    return $.ajax({
      url: "/?action=swissmed/app/csrf-token",
      dataType: "json",
      success: (response) => {
        if (response.csrfToken) {
          Craft.csrfToken = response.csrfToken;
        }
      },
    });
  }
}

window.App = new App();
